import { useState } from "react";
import REQUEST_SERVICE from "../../api/request";

export default function Contact() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        interest: "",
        position: "",
        agreeToTerms: false,
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.firstName || !formData.lastName || !formData.email || !formData.interest || !formData.position) {
            alert("Please fill in all required fields");
            return;
        }

        if (!formData.agreeToTerms) {
            alert("Please agree to the Terms of Service and Privacy Policy");
            return;
        }

        setIsSubmitting(true);

        try {
            const requestData = {
                fname: formData.firstName,
                lname: formData.lastName,
                email: formData.email,
                interest: formData.interest,
                position: formData.position,
            };

            const response = await REQUEST_SERVICE.create(requestData);

            if (response && !response.error) {
                setIsSubmitted(true);
                // Reset form after 2 seconds
                setTimeout(() => {
                    setFormData({
                        firstName: "",
                        lastName: "",
                        email: "",
                        interest: "",
                        position: "",
                        agreeToTerms: false,
                    });
                    setIsSubmitted(false);
                }, 2000);
            } else {
                alert(response?.message || "Failed to submit request. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("An error occurred. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
      <section
        className="mb-16"
        id="contact"
      >
        <div className=" bg-white rounded-lg shadow-md overflow-hidden">
          <div className="p-6 md:p-12">
            <h2 className="text-3xl font-bold mb-6 text-[#0258DA]">
              Students Matter <span className="underline decoration-red-500">Most</span>
            </h2>
            <p className="text-[#465362] mb-8 text-justify">
              Unlock access to collaborate on upcoming developments and stay ahead with industry
              insights as we remain focused on campus innovation.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label
                    htmlFor="firstName"
                    className="block text-sm font-medium text-[#465362] mb-1"
                  >
                    First Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Your first name"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="lastName"
                    className="block text-sm font-medium text-[#465362] mb-1"
                  >
                    Last Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Your last name"
                    required
                  />
                </div>
              </div>

              <div className="mb-6">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-[#465362] mb-1"
                >
                  Email Address <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Your email"
                  required
                />
              </div>

              <div className="mb-6">
                <label
                  htmlFor="interest"
                  className="block text-sm font-medium text-[#465362] mb-1"
                >
                  Interest <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  id="interest"
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                >
                  <option
                    value=""
                    disabled
                  >
                    Select your interest
                  </option>
                  <option value="Product Design">Product Design</option>
                  <option value="Team Leadership">Team Leadership</option>
                  <option value="Fundraising">Fundraising</option>
                  <option value="Marketing & Communications">Marketing & Communications</option>
                  <option value="Program Logistics">Program Logistics</option>
                </select>
              </div>

              <div className="mb-6">
                <label
                  htmlFor="position"
                  className="block text-sm font-medium text-[#465362] mb-1"
                >
                  Current Position <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  id="position"
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                >
                  <option
                    value=""
                    disabled
                  >
                    Select Current Position
                  </option>
                  <option value="Student">Student</option>
                  <option value="Industry Partner">Industry Partner</option>
                  <option value="Community Leader">Community Leader</option>
                  <option value="Professional">Professional</option>
                </select>
              </div>

              {/*<div className="mb-6">*/}
              {/*    <label*/}
              {/*        htmlFor="position"*/}
              {/*        className="block text-sm font-medium text-[#465362] mb-1"*/}
              {/*    >*/}
              {/*        Your Current Position*/}
              {/*    </label>*/}
              {/*    <div className="grid grid-cols-2 gap-2">*/}
              {/*        <label className="flex items-center">*/}
              {/*            <input*/}
              {/*                type="checkbox"*/}
              {/*                className="w-4 h-4 text-[#0258DA] border-gray-300 rounded focus:ring-blue-500"*/}
              {/*            />*/}
              {/*            <span className="ml-2 text-sm text-[#465362]">Student</span>*/}
              {/*        </label>*/}
              {/*        <label className="flex items-center">*/}
              {/*            <input*/}
              {/*                type="checkbox"*/}
              {/*                className="w-4 h-4 text-[#0258DA] border-gray-300 rounded focus:ring-blue-500"*/}
              {/*            />*/}
              {/*            <span className="ml-2 text-sm text-[#465362]">Industry Partner</span>*/}
              {/*        </label>*/}
              {/*        <label className="flex items-center">*/}
              {/*            <input*/}
              {/*                type="checkbox"*/}
              {/*                className="w-4 h-4 text-[#0258DA] border-gray-300 rounded focus:ring-blue-500"*/}
              {/*            />*/}
              {/*            <span className="ml-2 text-sm text-[#465362]">Community Leader</span>*/}
              {/*        </label>*/}
              {/*        <label className="flex items-center">*/}
              {/*            <input*/}
              {/*                type="checkbox"*/}
              {/*                className="w-4 h-4 text-[#0258DA] border-gray-300 rounded focus:ring-blue-500"*/}
              {/*            />*/}
              {/*            <span className="ml-2 text-sm text-[#465362]">Professional</span>*/}
              {/*        </label>*/}
              {/*    </div>*/}
              {/*</div>*/}

              <div className="mb-8">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="agreeToTerms"
                    checked={formData.agreeToTerms}
                    onChange={handleChange}
                    className="w-4 h-4 text-[#0258DA] border-gray-300 rounded focus:ring-blue-500"
                    required
                  />
                  <span className="ml-2 text-sm text-[#465362]">
                    I agree to the Terms of Service and Privacy Policy
                  </span>
                </label>
              </div>

              <div style={{display: 'flex', justifyContent: 'center'}}>
                <button
                  type="submit"
                  disabled={isSubmitting || isSubmitted}
                  className={`w-auto btn-primary ${
                    isSubmitted ? "bg-green-500 hover:bg-green-600" : ""
                  }`}
                  style={isSubmitted ? { backgroundColor: "#10b981" } : {}}
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Submitting...
                    </span>
                  ) : isSubmitted ? (
                    "Submitted"
                  ) : (
                    "Join Our Network"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
}
